<template>
<div id="app">

    <div v-if='isLoading' class="loading">
        <Jumper :size="90"></Jumper>
    </div>

    <div v-else>
        <router-view></router-view>
    </div>

</div>
</template>

<script>
    import { HTTPFront } from './share.js';
    import { Jumper } from 'vue-loading-spinner';
    import { mapState, mapGetters } from 'vuex';
    
    export default {
        data () {
            return {
                dataMenu: ''
            }
        },
        computed: {
            ...mapState([
                'isLoading',
                'isInitStatus'
            ])
        },
        components: {
            Jumper
        },        
        created() {
            this.$store.dispatch('InitStatus');
            this.getMenu();
        },
        methods: {
            getMenu() {

            },
            goRoute(menuOption) {
                switch (menuOption.route) {
                    case 'logout':
                        this.cerrarSesion();
                    break;
                    default:
                        this.$router.push(menuOption.route)
                    break;
                }
            },
            cerrarSesion() {
                //this.$router.push('logout')
                window.location = "/logout";
            }
        }
    } 

</script>

<style lang="scss">

</style>
